module.exports = __webpack_public_path__ + "img/globalway_black.e77f8ec1.png";